// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"29":"37acc2d8","229":"6544c45c","427":"fb28a802","579":"ff671a00","723":"65d02ce3","787":"390973e3","957":"1d9dd46f"}[chunkId] + ".chunk.js";
};